// extracted by mini-css-extract-plugin
export default {"DropDown":"SearchDropdown_DropDown__ZqMnw"};